import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeSelector.css';

const ThemeSelector = ({ compact = false }) => {
  const { currentTheme, themes, changeTheme } = useTheme();

  const themeOptions = [
    { key: 'light', icon: '☀️', label: 'Light' },
    { key: 'dark', icon: '🌙', label: 'Dark' },
    { key: 'blue', icon: '🌊', label: 'Ocean Blue' },
    { key: 'purple', icon: '💜', label: 'Royal Purple' },
    { key: 'green', icon: '🌲', label: 'Forest Green' },
    { key: 'sunset', icon: '🌅', label: 'Sunset Orange' }
  ];

  if (compact) {
    return (
      <div className="theme-selector-compact">
        <label className="theme-label">Theme:</label>
        <select 
          value={currentTheme} 
          onChange={(e) => changeTheme(e.target.value)}
          className="theme-select"
        >
          {themeOptions.map(option => (
            <option key={option.key} value={option.key}>
              {option.icon} {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className="theme-selector">
      <h3 className="theme-selector-title">Choose Your Theme</h3>
      <p className="theme-selector-description">
        Select a theme that suits your preference. Your choice will be saved automatically.
      </p>
      
      <div className="theme-grid">
        {themeOptions.map(option => {
          const theme = themes[option.key];
          const isActive = currentTheme === option.key;
          
          return (
            <button
              key={option.key}
              className={`theme-card ${isActive ? 'active' : ''}`}
              onClick={() => changeTheme(option.key)}
              aria-label={`Select ${option.label} theme`}
            >
              <div 
                className="theme-preview"
                style={{
                  background: `linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryDark} 100%)`
                }}
              >
                <span className="theme-icon">{option.icon}</span>
              </div>
              
              <div className="theme-info">
                <h4 className="theme-name">{option.label}</h4>
                <div className="theme-colors">
                  <span 
                    className="color-dot" 
                    style={{ backgroundColor: theme.colors.primary }}
                    title="Primary"
                  />
                  <span 
                    className="color-dot" 
                    style={{ backgroundColor: theme.colors.success }}
                    title="Success"
                  />
                  <span 
                    className="color-dot" 
                    style={{ backgroundColor: theme.colors.warning }}
                    title="Warning"
                  />
                  <span 
                    className="color-dot" 
                    style={{ backgroundColor: theme.colors.danger }}
                    title="Danger"
                  />
                </div>
              </div>
              
              {isActive && (
                <div className="theme-active-badge">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path 
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
                      fill="currentColor"
                    />
                  </svg>
                  Active
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ThemeSelector;

// ---
